<script>
import axios from "axios";

const ENABLE_CHECK = false;

export default {
  emits: ["close-modal", "refetch-history"],
  data() {
    return {
      selectedScrapper: undefined,
      selectedAgent: undefined,

      password: undefined,
      username: undefined,

      checkCredentialsIsPending: undefined,
      checkCredentialsIsError: undefined,
      checkCredentialsIsSuccess: undefined,

      updateCredentialsIsSuccess: undefined,
      updateCredentialsIsError: undefined,
      updateCredentialsErrors: undefined,
      updateCredentialsIsPending: undefined,

      fetchSelectedIsPending: undefined,
      fetchSelectedIsSuccess: undefined,
      fetchSelectedIsError: undefined,
      fetchSelectedError: undefined,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    agent: {
      type: [Object],
      required: false,
      default: undefined,
    },
  },
  methods: {
    async checkCredentials() {
      this.checkCredentialsIsPending = true;
      try {
        const { data, status } = await axios.get(
          `/api/admin/agentes/${this.agent_id}/check-credentials`
        );

        if (status >= 200 && data?.exists) {
          this.checkCredentialsIsSuccess = true;
        } else {
          this.checkCredentialsIsSuccess = false;
        }
      } catch (e) {
        console.error(e);
        this.checkCredentialsIsError = true;
      }
      this.checkCredentialsIsPending = false;
    },

    async fetchSelected(){
      this.fetchSelectedIsPending = true;
      try{
        const query = {
          params: {
            scrapper_type: this.selectedScrapper
          }
        }
        const { data } = await axios.get(`/api/admin/agentes/${this.agent?.value}/credentials`, query);
      
        if(data?.data?.username) {
          this.username = data.data.username;  
          
        }else{
          this.username = '';  
        };
        
        this.fetchSelectedIsError = false;
        this.fetchSelectedIsSuccess = true;
      }catch(err){
        this.fetchSelectedIsError = true;

        this.$swal({
          icon: 'error',
          title: 'Error',
          text:' Hubo un error al obtener los datos del agente'
        });
      }
      this.fetchSelectedIsPending = false;
    },

    async updateCredentials() {
      if (ENABLE_CHECK) await this.checkCredentials();

      this.updateCredentialsIsPending = true;

      const query = {
        agente_id: +this.agent?.value,
        scrapper_type_id: +this.selectedScrapper,
        username: this.username,
        password: this.password, // TODO : ENCRYPT THIS?
      };

      try {
        await axios.post(`/api/admin/agentes/historial-credenciales`, query);
        this.updateCredentialsIsSuccess = true;
        this.$emit("refetch-history");

        this.$swal({
          icon: "success",
          title: "¡Exito!",
          text: "Credenciales de agente actualizadas exitósamente.",
        });

        this.$emit("close-modal");
      } catch (error) {
        this.updateCredentialsIsSuccess = false;
        this.updateCredentialsIsError = true;

        if (error && error.response?.status == 422)
          this.updateCredentialsErrors = error.response?.data?.errors;
      }
      this.updateCredentialsIsPending = false;
    },
  },
  watch: {
    visible: function(newValue){
      if(newValue == true){
        this.selectedScrapper = undefined;
      }
    },  
    agent: function (newValue) {
      this.username = newValue.ultima_credencial?.username;
      this.updateCredentialsErrors = undefined;
      //this.password = newValue.ultima_credencial?.password;       // NO POINT SETTING PASSWORD HERE... MAYBE JUST SET A PLACEHOLDER
    },
  },
};
</script>

<template>
  <div>
    <b-modal :visible="visible">
      <template v-slot:modal-header>
        Actualizar credenciales de {{ agent?.key }}
      </template>

      <div class="flex flex-col gap-4">
        <div class="flex flex-row gap-4 p-3 items-center rounded-md bg-amber-500/20 cursor-default">
          <fas :icon="['fas', 'info']" class="mx-auto mb-auto mt-1" />
     
            En esta sección podrás configurar las credenciales de los sitios donde se va a ejecutar el scrapper.
 
        </div>

        <div class="flex flex-col">
          <label>Tipo</label>
          <select v-model="selectedScrapper" @change="() => fetchSelected()">
            <option :selected="!selectedScrapper" disabled>
              Seleccione un scrapper
            </option>
            <option value="1">Comext</option>
            <option value="2">TGR</option>
          </select>
        </div>

        <div v-if="selectedScrapper">
          <div class="flex flex-col">
            <label>Usuario</label>
            
            <input v-model="username" />
            <label
              class="text-red-500"
              v-if="updateCredentialsIsError"
              v-for="error in updateCredentialsErrors?.username"
              >{{ error }}</label
            >
          </div>

          <div class="flex flex-col">
            <label>Contraseña</label>
            <input
              v-model="password"
              :placeholder="'••••••••'"
              type="password"
            />
            <label
              class="text-red-500"
              v-if="updateCredentialsIsError"
              v-for="error in updateCredentialsErrors?.password"
              >{{ error }}</label
            >
          </div>
        </div>

        <div class="flex flex-col gap-4 h-32">
          <b-spinner
            v-if="checkCredentialsIsPending || updateCredentialsIsPending || fetchSelectedIsPending"
            class="p-4 text-primary"
          />
        </div>
      </div>

      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn-secundario"
          @click="$emit('close-modal')"
        >
          Cancelar
        </button>
        <button
          type="button"
          @click="() => updateCredentials()"
          class="btn-principal"
          :disabled="updateCredentialsIsPending"
        >
          Actualizar
        </button>
      </template>
    </b-modal>
  </div>
</template>
